import React, { forwardRef } from "react";

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerClassName?: string;
  style?: React.CSSProperties;
  tabIndex?: number;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  children?: React.ReactNode;
  id?: string;
  inputRef?: React.Ref<HTMLInputElement>;
}

const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  (
    {
      checked,
      onChange,
      containerClassName = "",
      style,
      tabIndex = 0,
      onClick,
      disabled = false,
      children,
      id,
      inputRef,
    },
    ref
  ) => {
    return (
      <div
        className={`toggle-container ${containerClassName}`}
        onClick={onClick}
        tabIndex={disabled ? -1 : tabIndex}
        role="checkbox"
        aria-checked={checked}
        aria-disabled={disabled}
      >
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          tabIndex={disabled ? -1 : tabIndex}
          disabled={disabled}
          className="toggle-switch"
          style={style}
          ref={(el) => {
            if (typeof ref === "function") ref(el);
            else if (ref)
              (ref as React.MutableRefObject<HTMLInputElement | null>).current =
                el;
            if (inputRef) {
              if (typeof inputRef === "function") inputRef(el);
              else
                (
                  inputRef as React.MutableRefObject<HTMLInputElement | null>
                ).current = el;
            }
          }}
        />
        {children}
      </div>
    );
  }
);

ToggleSwitch.displayName = "ToggleSwitch";

export default ToggleSwitch;
